import { API_URL_UTIL } from './../@core/utils/api-url.utils';
import { Injectable } from "@angular/core";
import { BaseCrudService } from "../@core/services";

@Injectable({ providedIn: 'root' })
export class ForemanService extends BaseCrudService {

  getBaseAPIPath(): string {
    return API_URL_UTIL.foreman.root;
  }

}
